var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiRrCrossSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#869499",
  d: "M12 4a.667.667 0 0 0-.943 0L8 7.057 4.943 4A.667.667 0 0 0 4 4.943L7.057 8 4 11.057a.667.667 0 0 0 .943.943L8 8.943 11.057 12a.667.667 0 0 0 .943-.943L8.943 8 12 4.943A.667.667 0 0 0 12 4"
})));
export { SvgFiRrCrossSmall as ReactComponent };
export default __webpack_public_path__ + "2ba85fd65de7274081441159fe97c385.svg";